import { StringUtil } from 'utils/StringUtil';
import { filter } from 'lodash';
import { PRODUCT_NEWS_DOWNLOAD_URL } from 'config/env';

const getAboutNews = (state, type, vertical_name) => {
  const newsData = state.AboutReducer.news;
  if (!newsData || !state.home.verticals || newsData.length === 0) return null;
  return formatNewsData(newsData, type, state.home.verticals, vertical_name);
};

const getAboutNewsLoading = state => {
  return state.AboutReducer.loading.news;
};

const getAboutNewsError = state => {
  return state.AboutReducer.error.news;
};

const formatNewsData = (data, type, vertical_list, vertical_name) => {
  let { news_publication = [], media_path, device } = data;
  let result_news_data = [];
  const media_path_mobile = `${media_path}${device.mobile}`;
  const media_path_web = `${media_path}${device.web}`;
  const media_path_thumbnail = `${media_path}${device.thumbnail}`;
  const url_pdf = `${PRODUCT_NEWS_DOWNLOAD_URL}`;
  news_publication = checkVerticalId(
    vertical_list,
    vertical_name,
    news_publication
  );
  news_publication.map(data => {
    if (data.type === type) {
      const news_data = {
        id: data.id,
        title: data.title,
        description: data.description,
        picture: `${media_path_web}/${data.picture}`,
        mobile_picture: `${media_path_mobile}/${data.mobile_picture}`,
        pdf_file: data.pdf_file,
        pdf_path: data.pdf_file ? `${url_pdf}${data.pdf_file}` : null,
        published_on: new Date(data.published_on).toString().slice(11, 15),
        media_path_thumbnail: `${media_path_thumbnail}/${data.picture}`,
        media_path_thumbnail_mobile: `${media_path_thumbnail}/${data.mobile_picture}`,
      };
      result_news_data.push(news_data);
    }
  });
  return { result_news_data };
};

const checkVerticalId = (vertical_list, vertical_name, parent_data) => {
  let result = parent_data;
  vertical_list.map(vertical_data => {
    let slicedVerticalName = StringUtil.lowerCaseString(
      StringUtil.sliceHtml(vertical_data.sanitizedName)
    );
    if (slicedVerticalName.includes(vertical_name)) {
      if (vertical_name) {
        result = filter(
          parent_data,
          ({ vertical_id }) => vertical_id === vertical_data.id
        );
      }
    }
  });
  return result;
};

export const AboutPageSelector = {
  getAboutNews,
  getAboutNewsLoading,
  getAboutNewsError,
};
